import '../styles/loader.modules.scss'



function myLoader(props) {




    return(

    <>
    <div className={"loader " + props.customClass }>
        
    </div>
    </>
    )
}

export default myLoader;